import { getSharedConfig } from '../get-config'
import { setWebpackPublicPath } from '../set-public-path'

const { PUBLIC_PATH } = getSharedConfig()

if (PUBLIC_PATH && PUBLIC_PATH !== '/') {
  setWebpackPublicPath(PUBLIC_PATH)
}
